import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Card } from "primereact/card";
import { Divider } from 'primereact/divider';
import { Dialog } from "primereact/dialog";
import { ITrainingForm } from "./Table";
import { format } from "date-fns";

interface IProps {
    open: boolean,
    singleData: ITrainingForm,
    form_ID: number,
    hideDialog: () => void,
    toast: any
}

const default1 = {
    no_Of_Trainees: 0,
    branchName: "",
    training_Date: null,
    // training_Date_To: null,
    training_Time_From: null,
    training_Time_To: null,
};

interface IDef {
    no_Of_Trainees: number,
    branchName: string,
    training_Date: Date | null,
    // training_Date_To: Date | null,
    training_Time_From: Date | null,
    training_Time_To: Date | null,
}


export const MultiTrainingSchedulerForm = (props: IProps) => {
    const [branchs, setBranchs] = useState<Array<string>>([]);
    const [changeMade, setChangeMade] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<Array<{
        no_Of_Trainees: number,
        branchName: string,
        training_Date: Date | null,
        // training_Date_To: Date | null,
        training_Time_From: Date | null,
        training_Time_To: Date | null,
    }>>([default1]);

    const loadBranchs = async () => {
        const res = await Fetch("CarnivalTraining/getBranchNames", "GET", null, null, props.toast);
        if (res) {
            const data: string[] = await res.json();
            setBranchs(data);
        }
    }

    const onSave = async () => {
        setLoading(true);
        const method = "POST";
        const message = "Added Successfully";
        const url = "addMultipleTrainingSchedules";

        let isTimeIssue: boolean | null = null;
        let isTimeIssueIndex: number | null = null;

        let isDataIssue: boolean | null = null;
        let isDataIssueIndex: number | null = null;
        let isDataIssueType: string | null = "";

        const newData = data.map((ele: any, index: number) => {
            if (ele.no_Of_Trainees === null || ele.branchName === null || ele.training_Date_From === null || ele.training_Date_To === null || ele.training_Time_From === null || ele.training_Time_To === null) {
                if (ele.no_Of_Trainees === null || ele.no_Of_Trainees === 0) {
                    isDataIssue = true;
                    isDataIssueIndex = index;
                    isDataIssueType = isDataIssueType + "No Of Trainees ,";
                }
                if (ele.branchName === null) {
                    isDataIssue = true;
                    isDataIssueIndex = index;
                    isDataIssueType = isDataIssueType + "Training Branch, ";
                }
                if (ele.training_Date_From === null) {
                    isDataIssue = true;
                    isDataIssueIndex = index;
                    isDataIssueType = isDataIssueType + "Training Date From, ";
                }
                if (ele.training_Date_To === null) {
                    isDataIssue = true;
                    isDataIssueIndex = index;
                    isDataIssueType = isDataIssueType + "Training Date To, ";
                }
                if (ele.training_Time_From === null) {
                    isDataIssue = true;
                    isDataIssueIndex = index;
                    isDataIssueType = isDataIssueType + "Training Time From, ";
                }
                if (ele.training_Time_To === null) {
                    isDataIssue = true;
                    isDataIssueIndex = index;
                    isDataIssueType = isDataIssueType + "Training Time To, ";
                }
                return { ...ele, Form_ID: props.singleData.form_ID };
            }

            ele.training_Time_From = format(new Date(ele.training_Time_From || ""), "yyyy-MM-dd HH:mm:ss");
            ele.training_Time_To = format(new Date(ele.training_Time_To || ""), "yyyy-MM-dd HH:mm:ss");
            // ele.training_Time_From = new Date(new Date().getFullYear(),
            //     new Date().getMonth(),
            //     new Date().getDate(),
            //     new Date(ele.training_Time_From || "").getHours() - 5,
            //     new Date(ele.training_Time_From || "").getMinutes(),
            //     new Date(ele.training_Time_From || "").getSeconds());
            // ele.training_Time_To = new Date(new Date().getFullYear(),
            //     new Date().getMonth(),
            //     new Date().getDate(),
            //     new Date(ele.training_Time_To || "").getHours() - 5,
            //     new Date(ele.training_Time_To || "").getMinutes(),
            //     new Date(ele.training_Time_To || "").getSeconds());

            if (new Date(ele.training_Time_From || "").getHours() > new Date(ele.training_Time_To || "").getHours()) {
                isTimeIssue = true;
                isTimeIssueIndex = index;
            } else if (new Date(ele.training_Time_From || "").getHours() === new Date(ele.training_Time_To || "").getHours() && (new Date(ele.training_Time_From || "").getMinutes() >= new Date(ele.training_Time_To || "").getMinutes())) {
                isTimeIssue = true;
                isTimeIssueIndex = index;
            }

            return { ...ele, Form_ID: props.singleData.form_ID };
        });

        if (isDataIssue === true && isDataIssueIndex !== null) {
            props.toast.current.show({ severity: 'error', detail: `${isDataIssueType} is Required in Form No. ${isDataIssueIndex + 1}`, life: 3000 });
            setLoading(false);
        } else if (isTimeIssue === true && isTimeIssueIndex !== null) {
            props.toast.current.show({ severity: 'error', detail: `Time From Can not be greater than Time To in Form No. ${isTimeIssueIndex + 1}`, life: 3000 });
            setLoading(false);
        } else {
            const response = await Fetch(("CarnivalTraining/" + url), method, newData, null, props.toast);

            if (response) {
                setLoading(false);
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                onHide();
            } else {
                setLoading(false);
                onHide();
            }
        }

    }

    const onHide = () => {
        setData([{
            no_Of_Trainees: 0,
            branchName: "",
            training_Date: null,
            // training_Date_To: null,
            training_Time_From: null,
            training_Time_To: null,
        }]);
        setLoading(false);
        props.hideDialog();
    }

    useEffect(() => {
        loadBranchs();
    }, []);

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header="Add Schedules" modal className="p-fluid" onHide={onHide}>
            <div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-between align-items-center">
                    <h3 className="underline">{props.singleData?.trainer_Name} | {props.singleData?.category_Name} | {props.singleData?.topic_Name}</h3>
                    <Button style={{ width: '150px' }} label="ADD MORE" onClick={() => {
                        let newData1: IDef[] = data;
                        if (new Date(data[data.length - 1].training_Time_From || "") > new Date(data[data.length - 1].training_Time_To || "")) {
                            props.toast.current.show({ severity: 'error', detail: "Time From Can not be greater than Time To", life: 3000 });
                        } else if (data[data.length - 1].no_Of_Trainees <= 0 || data[data.length - 1].no_Of_Trainees === null) {
                            props.toast.current.show({ severity: 'error', detail: "Please enter No Of Trainee", life: 3000 });
                        } else if (data[data.length - 1].branchName === null) {
                            props.toast.current.show({ severity: 'error', detail: "Please select a Branch", life: 3000 });
                        } else if (data[data.length - 1].training_Date === null) {
                            props.toast.current.show({ severity: 'error', detail: "Please enter Training Date", life: 3000 });
                        }
                        // else if (data[data.length - 1].training_Date_To === null) {
                        //     props.toast.current.show({ severity: 'error', detail: "Please enter To Date", life: 3000 });
                        // } 
                        else {
                            newData1.push({
                                no_Of_Trainees: 0,
                                branchName: "",
                                training_Date: null,
                                // training_Date_To: null,
                                training_Time_From: null,
                                training_Time_To: null,
                            });
                            setData(prev => prev = newData1);
                            setChangeMade(!changeMade);
                        }
                    }} type="button"></Button>
                </div>
                {data.map((ele: {
                    no_Of_Trainees: number,
                    branchName: string,
                    training_Date: Date | null,
                    // training_Date_To: Date | null,
                    training_Time_From: Date | null,
                    training_Time_To: Date | null,
                }, index: number) => {
                    return (
                        <Card className="mt-2">
                            <div key={index} className="p-fluid formgrid grid">
                                <div className="field col-12 md:col-3">
                                    <label>No Of Trainees<span style={{ color: 'red' }}>*</span></label>
                                    <InputNumber value={ele.no_Of_Trainees} min={0} onValueChange={(e: any) => {
                                        if (Number(e.value) >= 0) {
                                            let newData: any[] = data;
                                            newData[index].no_Of_Trainees = Number(e.value);
                                            setData(prev => prev = newData);
                                        }
                                    }} style={{ height: "34px" }} />
                                </div>
                                <div className="field col-12 md:col-3">
                                    <label>Branch<span style={{ color: 'red' }}>*</span></label>
                                    <Dropdown value={ele.branchName} onChange={(e: any) => {
                                        let newData: any[] = data;
                                        newData[index].branchName = e.value;
                                        setData(prev => prev = newData);
                                        setChangeMade(!changeMade);
                                    }} options={branchs} optionValue="branchName" optionLabel="branchName" placeholder="Select Branch" style={{ height: "34px" }} />
                                </div>
                                <div className="field col-12 md:col-3">
                                    <label>Training Date<span style={{ color: 'red' }}>*</span></label>
                                    <Calendar value={ele.training_Date} onChange={(e: any) => {
                                        let newData: any[] = data;
                                        newData[index].training_Date = new Date(e.target.value || "");
                                        setData(prev => prev = newData);
                                    }} dateFormat="dd/mm/yy" showIcon />
                                </div>
                                {/* <div className="field col-12 md:col-3">
                                    <label>To Date<span style={{ color: 'red' }}>*</span></label>
                                    <Calendar value={ele.training_Date_To} onChange={(e: any) => {
                                        let newData: any[] = data;
                                        newData[index].training_Date_To = new Date(e.target.value || "");
                                        setData(prev => prev = newData);
                                    }} dateFormat="dd/mm/yy" showIcon />
                                </div> */}
                                <div className="field col-12 md:col-3">
                                    <label>Time From<span style={{ color: 'red' }}>*</span></label>
                                    <Calendar value={ele.training_Time_From} onChange={(e: any) => {
                                        let newData: any[] = data;
                                        newData[index].training_Time_From = e.value;
                                        setData(prev => prev = newData);
                                        setChangeMade(!changeMade);
                                    }} timeOnly hourFormat="12" />
                                </div>
                                <div className="field col-12 md:col-3">
                                    <label>Time To<span style={{ color: 'red' }}>*</span></label>
                                    <Calendar value={ele.training_Time_To} onChange={(e: any) => {
                                        let newData: any[] = data;
                                        newData[index].training_Time_To = e.value;
                                        setData(prev => prev = newData);
                                        setChangeMade(!changeMade);
                                    }} timeOnly hourFormat="12" />
                                </div>
                                <div className="field col-12 md:col-6 flex flex-row-reverse">
                                    {data.length > 1 && <Button style={{ width: "5rem", height: "34px", marginTop: "1.7rem", color: "red" }} className="pi pi-trash bg-white border-none" onClick={() => {
                                        let newData: any[] = data;
                                        newData.splice(index, 1);
                                        setData(prev => prev = newData);
                                        setChangeMade(!changeMade);
                                    }}></Button>}
                                </div>
                            </div>
                        </Card>
                    );
                })}
                <Divider />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="button" onClick={() => onSave()} loading={loading} disabled={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </div>
        </Dialog>
    );
}